<template>
  <div class="empty">
    <!-- placeholder -->
  </div>
</template>

<script>
import { productGetters } from '@vue-storefront/gemini';
import {
  getPriceFixedDecimals,
} from '~/helpers/product/productData';

export default {
  name: 'CategoryGtm',
  props: {
    productsData: {
      type: Array,
      required: false,
      default() {
        return [];
      },
    },
  },
  mounted() {
    this.$nextTick(() => {
      const productList = this.getGtmData();
      const categoryId = this.getCategoryId();
      this.$gtm.push({
        event: 'view_item_list',
        categoryProducts: {
          ...productList,
        },
        categorySize: productList.length,
        categoryId: (categoryId !== 0) ? categoryId : 0,
        categoryName: (productList.length > 0) ? productList[0].category : '',
        PageType: 'product-list',
      });
    });
  },
  methods: {
    getGtmData() {
      if (this.productsData.length === 0) return [];

      const productList = [];
      let i = 0;

      this.productsData.forEach((product) => {
        if (product !== undefined) {
          // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
          const price = productGetters.getPrice(product);

          productList.push({
            // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
            name: productGetters.getName(product),
            // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
            product_id: productGetters.getProductMerchantSku(product),
            price: price?.special ? price.special : price.regular,
            // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
            category: productGetters.getCategoryNameListingPage(product, window.location.pathname),
            position: i,
            currency: 'EUR',
            discount: price?.special ? getPriceFixedDecimals((price.regular - price.special).toFixed(2)) : '0.00',
            full_price: getPriceFixedDecimals(price.regular.toFixed(2)),
          });
          i += 1;
        }
      });

      return productList;
    },
    getCategoryId() {
      if (this.productsData.length === 0) return 0;
      // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
      return productGetters.getCategoryIdListingPage(this.productsData[0], window.location.pathname);
    },
  },

};
</script>

<style scoped>

</style>
